import React from 'react';
import { CENIA_PHOTO, stats } from '../data/seminar';
export function AboutCenia() {
  return <section className="w-full bg-cream py-20 sm:py-28" data-id="element-11" data-mp="3lrvi53v3vhu5">
      <div className="mx-auto max-w-6xl px-6" data-id="element-12" data-mp="3ltey0tcunqve">
        <div className="mx-auto max-w-2xl text-center" data-id="element-13" data-mp="380qd1m8yxxcf">
          <span className="section-label" data-id="element-14" data-mp="37y43xi6fj9s3">Quién te acompaña</span>
          <h2 className="mt-5 font-serif text-4xl font-light leading-tight text-navy sm:text-5xl" data-id="element-15" data-mp="3c2btfhkpotrd">
            Tu guía en este camino
          </h2>
          <div className="mx-auto mt-7 h-px w-16 bg-gold" aria-hidden="true" data-id="element-16" data-mp="8ktrtrvj8ize" />
        </div>

        <div className="mt-14 grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-17" data-mp="3qqf4h5dm2vn1">
          <div className="relative mx-auto w-full max-w-md" data-id="element-18" data-mp="3qsj4hc8e3ai1">
            <div className="absolute -bottom-4 -right-4 h-full w-full rounded-2xl border border-gold" aria-hidden="true" data-id="element-19" data-mp="3vo6u1sqsa5o2" />
            <img src="https://i.imgur.com/8F8U6Hh.jpg" alt="Cenia Badillo, Realtor en Coldwell Banker Realty" className="relative aspect-[4/5] w-full rounded-2xl shadow-soft" style={{
            objectFit: 'cover',
            objectPosition: 'top center'
          }} data-id="element-20" data-mp="2ka336vfhsxn8" />
          </div>

          <div data-id="element-21" data-mp="1e2lf4qc4hjdn">
            <h3 className="font-serif text-4xl font-light text-navy sm:text-5xl" data-id="element-22" data-mp="1e338nf7ehjhv">Cenia Badillo</h3>
            <p className="mt-4 font-sans text-[11px] font-semibold uppercase tracking-[0.24em] text-gold" data-id="element-23" data-mp="192flx5q7fotg">
              Realtor · CB Realty · 21+ años de experiencia
            </p>
            <p className="mt-6 font-sans text-base font-light leading-relaxed text-ink sm:text-lg" data-id="element-24" data-mp="1i4oqzg2pepzg">
              He tenido la oportunidad de preparar a muchísimas familias para comprar su primera
              casa en Minnesota. Este seminario es para ti.
            </p>

            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-gold/50 pt-8" data-id="element-25" data-mp="25t81815bdcu6">
              {stats.map(stat => <div key={stat.label} data-id="element-26" data-mp="21sxm9yzjnc36">
                  <dt className="sr-only" data-id="element-27" data-mp="21ptaogjr1e2h">{stat.label}</dt>
                  <dd data-id="element-28" data-mp="28w5jcnv9x285">
                    <span className="block font-serif text-3xl font-medium text-gold sm:text-4xl" data-id="element-29" data-mp="28wnk9xsvs4me">
                      {stat.value}
                    </span>
                    <span className="mt-2 block font-sans text-[10px] font-semibold uppercase tracking-[0.22em] text-ink sm:text-[11px]" data-id="element-30" data-mp="2it0fj042qqj9">
                      {stat.label}
                    </span>
                  </dd>
                </div>)}
            </dl>
          </div>
        </div>
      </div>
    </section>;
}